var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-row customize-editor-minimize" },
    [
      _c("div", { staticClass: "editor-row-title" }, [
        _vm._v(_vm._s(_vm.$t("auto.stringFormatterWordcountCountSpaces"))),
      ]),
      _vm._v(" "),
      _c("a-switch", {
        model: {
          value: _vm.clone.word_count.countSpaces,
          callback: function ($$v) {
            _vm.$set(_vm.clone.word_count, "countSpaces", $$v)
          },
          expression: "clone.word_count.countSpaces",
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "description" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$t(
                "auto.stringFormatterWordcountIncludeSpacesInTheWordCountCalculation"
              )
            ) +
            "\n    "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }